const { captureAttribution } = require('./src/helpers/attribution');

// Fired once when the app first mounts in the browser.
exports.onClientEntry = () => {
  if (typeof window === 'undefined') return;
  // Capture first-touch attribution on the very first page hit.
  // (First-party only — stored in localStorage for lead forms/CRM. This is
  // NOT third-party analytics; the Google Ads / GA4 / Meta Pixel tags were
  // removed for launch. See html.js.)
  captureAttribution();

  // NOTE: the tel: click → Google Ads "Click to call" conversion + dataLayer
  // push were removed along with the rest of the third-party tracking. When
  // Domex's own gtag/GA4 is wired back in (html.js), restore a click handler
  // here that fires the conversion for Domex's Ads account.
};

// Fired on every client-side route change (and on initial page load).
exports.onRouteUpdate = ({ location, prevLocation }) => {
  if (typeof window === 'undefined') return;

  // Meta Pixel PageView removed for launch (pixel belonged to DC Controls).
  // When Domex's own pixel is added to html.js, restore fbq('track','PageView')
  // here so SPA route changes each register a view.

  if (!window.localStorage) return;

  // Persist last-touch + first-touch UTMs / landing URL / referrer.
  // First-touch wins by default; see src/helpers/attribution.js for rules.
  captureAttribution();

  // Legacy: keep the lNdUrL / crNtPaTH / prevPaTHnAme keys around for any
  // existing code that still reads them (forms, etc.).
  if (!window.localStorage.getItem('lNdUrL')) {
    window.localStorage.setItem('lNdUrL', location.href);
    window.localStorage.setItem('lNdUrLDtIme', new Date());
  }
  window.localStorage.setItem('crNtPaTH', location.href);
  window.localStorage.setItem(
    'prevPaTHnAme',
    prevLocation ? prevLocation.href : null
  );
};